import { useGetInTouchOverlay } from '@/components/get-in-touch-overlay'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type GetInTouchTriggerProps = {
  className?: string
  children?: React.ReactNode
}

export function GetInTouchTrigger({
  className,
  children = 'Get in touch',
}: GetInTouchTriggerProps) {
  const { open } = useGetInTouchOverlay()

  return (
    <Button
      type="button"
      className={cn(className)}
      onClick={(event) => open(event.currentTarget)}
    >
      {children}
    </Button>
  )
}
